import React, { Component } from 'react';
import '../../App.css'
import { Link } from 'react-router-dom';
import { Avisos } from '../logeo/Avisos';
import { FooterContactoQuadrum } from '../../FooterContactoQuadrum';
import { ImagenLogoCapufe } from '../../ImagenLogoCapufe';
import FacturacionTickets from './FacturacionTickets';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
export class FacturacionSinRegistro extends Component {
  constructor() {
    super();
    this.state = {
      esFacturacionSingistro: true,
      urlBusquedaTickets: 'sinregistro/ticket/buscar_tickets.json',
      urlBusquedaReceptor: 'sinregistro/receptor/buscar_receptor_por_rfc.json',
      urlBusquedaUsosCfdi: 'sinregistro/usocfdi40/uso_cfdi_por_rfc.json',
      urlValidarTickets: 'sinregistro/ticket/validar.json',
      urlEliminarTickets: 'sinregistro/ticket/eliminar.json',
      urlGenerarFacturaTickets: 'sinregistro/ticket/facturar.json',
      urlDescargaArchivosFacturacion: 'sinregistro/documentos/descargarzip.json',
      urlObtenerElementosIne11: 'sinregistro/ine/obtener_elementos_ine11.json',
      urlDescargaArchivosCodigoAlfanumetico:'sinregistro/documentos/descargar_codigo_alfanumerico.json?codigo=',
      urlRegimenFiscal:'sinregistro/regimen/usocfdi_rfc.json',
      mostrarModal: false,
      ticket: {},
      erroresFormulario: {},
      urlActualizarFechaTicket:'sinregistro/ticket/actualizar_fecha.json',
      urlValidarReceptor40:'sinregistro/receptor/validar_receptor40.json'
    }
  }
  mostrarModalRecuperaFactura = () => {
    this.setState({ mostrarModal: true });
  }
  asignarValoresObjeto = (event) => {
    if (event.target.id === "usoCfdi" || event.target.id === "correo")
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    else
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }
  recuperarFactura = () => {
    const { ticket,urlDescargaArchivosCodigoAlfanumetico } = this.state;
    const validacion = this.validarFormulario(ticket);
    this.setState({ erroresFormulario: validacion });
    if (!Object.keys(validacion).length) {
      servicioDescargaArchivos.descargaArchivo(urlDescargaArchivosCodigoAlfanumetico+ticket.codigo,null,this);

    }

  }
  validarFormulario = (objeto) => {
    const errores = {};
    if (!objeto.codigo)
      errores.codigo = "El campo es requerido";
    return errores;
  }

  cerrarModal=()=>{
    this.setState({ticket: {}, mostrarModal: false, erroresFormulario: {}})
   
  }


  render() {

    const { erroresFormulario, ticket, esFacturacionSingistro, urlBusquedaTickets, urlBusquedaReceptor, urlBusquedaUsosCfdi,
      urlValidarTickets, urlEliminarTickets, urlGenerarFacturaTickets, urlDescargaArchivosFacturacion, urlObtenerElementosIne11, urlActualizarFechaTicket,urlRegimenFiscal,urlValidarReceptor40} = this.state;
    const dialogFooter = (
      <div>
        <Button icon="pi-md-check" onClick={this.recuperarFactura} label="recuperar" className="teal-btn flat-btn" />
        <Button icon="pi-md-close" onClick={this.cerrarModal} label="Cancelar" className="p-button-danger flat-btn" />
      </div>
    );

    return (
      <div className="p-fluid">
        <Growl ref={(el) => this.growl = el} />
        <ImagenLogoCapufe />
        <div className="p-grid">
          <div className="p-col-12">
            <Avisos />
            <div className="p-grid">
              <div className="p-col-12 p-md-4">
                <Link to="/Capufe/facturacionrapida" style={{ border: "none", backgroundColor: "transparent", outline: "none", }} ><h2> <strong style={{ color: '#4CAF50' }}>Facturar sus códigos</strong></h2></Link>
              </div>
              <div className="p-col-12 p-md-4">
                <Link to="/Capufe/facturacionrapida" onClick={this.mostrarModalRecuperaFactura} style={{ border: "none", backgroundColor: "transparent", outline: "none", }} ><h2> <strong style={{ color: '#4CAF50' }}>Recuperar una factura, por código alfanúmerico</strong></h2></Link>
              </div>
              <div className="p-col-12 p-md-4">
                <button style={{ border: "none", backgroundColor: "transparent", outline: "none", }} ><h2> <strong style={{ color: '#4CAF50' }}>Aviso de Privacidad</strong></h2></button>
              </div>
            </div>

            <h2 style={{ textAlign: 'center', marginBottom: '16px', color: '#c8102e' }}>"Una vez emitida la factura no se podrá remitir a un RFC diferente ni corregir datos"</h2>
          </div>
        </div>
        <Dialog header="Recuperar Factura por Código Alfanumérico" scroll visible={this.state.mostrarModal} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={this.cerrarModal}>
          <div className="content-section implementation">
            <div className="p-grid p-fluid">

              <div className="p-col-12 p-md-12">
                <h4>Código Alfanumérico*:</h4>
                <InputText id="codigo" maxLength={18} name="ticket.codigo" value={ticket.codigo || ''} onChange={this.asignarValoresObjeto} className={erroresFormulario.codigo ? 'p-error' : ''} />
                {erroresFormulario.codigo ? <div> <Message severity="error" text={erroresFormulario.codigo} /> </div> : null}
              </div>
            </div>
          </div>

        </Dialog>

        <FacturacionTickets esFacturacionSingistro={esFacturacionSingistro} urlBusquedaTickets={urlBusquedaTickets} urlBusquedaReceptor={urlBusquedaReceptor} urlBusquedaUsosCfdi={urlBusquedaUsosCfdi}
          urlValidarTickets={urlValidarTickets} urlEliminarTickets={urlEliminarTickets} urlGenerarFacturaTickets={urlGenerarFacturaTickets}
          urlDescargaArchivosFacturacion={urlDescargaArchivosFacturacion} urlObtenerElementosIne11={urlObtenerElementosIne11} urlActualizarFechaTicket={urlActualizarFechaTicket} urlRegimenFiscal={urlRegimenFiscal} urlValidarReceptor40={urlValidarReceptor40}/>
        <FooterContactoQuadrum />
      </div>);
  }
}